import React, { useEffect, useState, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DatePicker from "react-datepicker";
import Popup from "../common/popup";
import { dateformatwithuktime } from "../utilityfunctions";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

export const Abandonedcart = ({}) => {
  const [popupView, setPopupView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [restrictedAccounts, setRestrictedAccounts] = useState([]);
  const [restrictedLoaded, setRestrictedLoaded] = useState(false);
  const { t } = useTranslation();
  // Load restricted accounts on component mount
  useEffect(() => {
    http
      .get(BaseUrl + "admin/accountcodelist")
      .then((res) => {
        const ids = res.data?.data?.map((acc) => acc.accountCode);
        setRestrictedAccounts(ids || []);
      })
      .catch((err) => {
        console.error("Failed to load restricted accounts", err);
        setRestrictedAccounts([]);
      })
      .finally(() => {
        setRestrictedLoaded(true);
      });
  }, []);
  // Format price with currency symbol and two decimal places
  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };
  // Memoize price formatting to avoid unnecessary recalculations
  const priceFormatCb = useCallback((price) => {
    return priceFormat(price);
  }, []);
  // Custom styles for the data table
  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };
  // Replace HTML entities in product names for better display
  const str_replace = (product_name) => {
    if (product_name !== "") {
      product_name = product_name.replaceAll("amp;", "&");
      product_name = product_name.replaceAll("apos;'", "'' ");
      product_name = product_name.replaceAll("quot;'", "'' ");
      return product_name;
    } else {
      return product_name;
    }
  };
  const strReplaceCb = useCallback((name) => str_replace(name), []);
  // Fetch cart items for a specific customer and display them in a popup
  const viewCartItems = useCallback((customer) => {
    const addressFields = [
      customer.accountinfo.accountAddress1,
      customer.accountinfo.accountAddress2,
      customer.accountinfo.accountAddress3,
      customer.accountinfo.accountAddress4,
      customer.accountinfo.accountAddress5,
    ];
    const info = { ...customer.accountinfo };
    info.addressInfo = addressFields
      .filter((field) => field !== undefined && field !== "")
      .join(", ");
    setCustomerDetails(info);
    setLoading(true);
    setCartItems([]);
    setPopupView(true);
    const URL = BaseUrl + "admin/cart/" + customer.accountinfo.accountCode;
    http
      .get(URL)
      .then((response) => {
        setCartItems(response?.data?.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);
  // Define columns for the data table, including a clickable link to view cart items
  const columns = useMemo(
    () => [
      {
        name: t("account_code_txt"),
        selector: (row) => row.accountCode,
        sortable: false,
      },
      {
        name: t("account_name_txt"),
        selector: (row) => row.accountinfo.accountName,
        sortable: false,
      },
      {
        name: t("email_address_txt"),
        selector: (row) => row.accountinfo.accountEmail,
        sortable: false,
      },
      {
        name: t("no_of_items_txt"),
        selector: (row) => (
          <a
            className="title-tooltip title-up button"
            data-title={t("view_items_txt")}
            style={{ color: "white" }}
            onClick={() => viewCartItems({ accountinfo: row.accountinfo })}
          >
            {row.itemsCount}
          </a>
        ),
        sortable: true,
      },
    ],
    [t, viewCartItems],
  );
  // Pagination options for the data table
  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };
  var currentTime = new Date();
  var currentyear = currentTime.getFullYear();
  var currentMonth = currentTime.getUTCMonth() + 1;
  const [filter, setFilter] = useState(0);
  const [filtertext, setFilterText] = useState("");
  const [abandonedcart, setAbandonedCart] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const getCurrentFiscalYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    // Fiscal year starts in September
    const startYear = month >= 9 ? year : year - 1;
    const endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  };
  const [period, setPeriod] = useState(getCurrentFiscalYear());
  const [months, setMonths] = useState("9");
  const [quarter, setQuarter] = useState("");
  // Define month names based on translations for better internationalization support
  const MonthNames = [
    t("months.sep"),
    t("months.oct"),
    t("months.nov"),
    t("months.dec"),
    t("months.jan"),
    t("months.feb"),
    t("months.mar"),
    t("months.apr"),
    t("months.may"),
    t("months.jun"),
    t("months.jul"),
    t("months.aug"),
  ];
  // Define quarter names based on translations for better internationalization support
  const quarterNames = {
    1: t("quarter_sep_nov"),
    2: t("quarter_dec_feb"),
    3: t("quarter_mar_may"),
    4: t("quarter_jun_aug"),
  };
  // Get the current fiscal quarter based on the current month for accurate filtering of quarterly data
  const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    if (month >= 9 && month <= 11) return 1; // Sep–Nov
    if (month === 12 || month <= 2) return 2; // Dec–Feb
    if (month >= 3 && month <= 5) return 3; // Mar–May
    return 4; // Jun–Aug
  };
  // Get available quarters based on the selected fiscal year to prevent selection of future quarters in the current fiscal year
  const getAvailableQuarters = (selectedFiscalYear) => {
    const currentFiscalYear = getCurrentFiscalYear();
    const currentQuarter = getCurrentFiscalQuarter();
    return Object.entries(quarterNames)
      .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
          return Number(quarterNumber) <= currentQuarter;
        }
        return true; // show all for past years
      })
      .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
          {label}
        </option>
      ));
  };
  // Set the default quarter based on the current month when the component mounts for better user experience in quarterly view
  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
      9: 1,
      10: 1,
      11: 1,
      12: 2,
      1: 2,
      2: 2,
      3: 3,
      4: 3,
      5: 3,
      6: 4,
      7: 4,
      8: 4,
    };
    const currentFiscalQuarter = fiscalQuarterMap[month];
    setQuarter(String(currentFiscalQuarter));
  }, []);
  // Fetch abandoned cart data based on the selected filter and date range, with loading state management and error handling
  useEffect(() => {
    if (!restrictedLoaded) {
      return;
    }
    setIsLoading(true);
    if (filter === "custom" && (!fromDate || !toDate)) {
      setIsLoading(false);
      // Don't make the API call if dates are missing for the "custom" filter
      return;
    }
    let payload = {};
    if (filter === "custom") {
      payload = {
        filter: filter,
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd"),
      };
      setShowDatePicker(false);
    } else if (["weekly", "monthly", "quarterly", "FYdata"].includes(filter)) {
      payload = {
        filter: filter,
        datefrom: "",
        dateto: "",
        period: period,
      };
    } else {
      payload = {
        filter: parseInt(filter),
        datefrom: "",
        dateto: "",
      };
    }
    let URL2 = BaseUrl + "admin/abandonedcart";
    http
      .post(URL2, payload)
      .then((response) => {
        setIsLoading(false);
        const actualMonth = parseInt(months);
        const responseData = response.data.data.filter(
          (item) => !restrictedAccounts.includes(item.accountCode),
        );
        const updatedData1 =
          filter === "monthly"
            ? responseData.filter((item) => item.month === actualMonth)
            : filter === "quarterly"
              ? responseData.filter((item) => item.quarter === Number(quarter))
              : responseData;
        setAbandonedCart(updatedData1);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [filter, fromDate, toDate, months, quarter, period, restrictedLoaded]);
  // Handle filter changes and show/hide date picker for custom date range selection, with state management for filter text and selected period
  const changeFilterHandler = useCallback((e) => {
    const val = e.target.value;
    setFilter(val);
    setFilterText(e.target.options[e.target.selectedIndex].text);
    if (val === "custom") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      setFromDate(null);
      setToDate(null);
    }
  }, []);
  // Handle changes to the fiscal year/period selection and adjust available months and quarters based on the selected fiscal year to prevent selection of future periods in the current fiscal year
  const changePeriodHandler = useCallback(
    (e) => {
      const newPeriod = e.target.value;
      setPeriod(newPeriod); // update selected fiscal year in state
      //split fiscal year
      const [newStartYear, newEndYear] = newPeriod.split("-").map(Number);
      const fiscalStartMonthIndex = 8; // 0-based index for September
      const today = new Date();
      const currentFiscalYear = getCurrentFiscalYear();
      //compare sleted year with currentfiscalyear
      const isCurrentFiscalYear = newPeriod === currentFiscalYear;
      // MONTHLY filter logic
      if (filter === "monthly") {
        let visibleMonthNames = MonthNames;
        if (isCurrentFiscalYear) {
          // Calculate current fiscal month index
          const currentMonthIndex = today.getMonth(); // 0-based
          const monthsPassedSinceFiscalStart =
            (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
          const maxVisibleIndex = monthsPassedSinceFiscalStart;
          visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
        }
        const selectedMonthIndex = MonthNames.indexOf(months);
        const isValidMonth =
          selectedMonthIndex >= 0 &&
          selectedMonthIndex < visibleMonthNames.length;
        if (!isValidMonth) {
          const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
          setMonths(String(defaultMonthNumber));
        }
      }
      // QUARTERLY filter logic
      if (filter === "quarterly") {
        const currentQuarter = getCurrentFiscalQuarter();
        let maxQuarter = 4;
        if (isCurrentFiscalYear) {
          maxQuarter = currentQuarter;
        }
        if (parseInt(quarter) > maxQuarter) {
          setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
        }
      }
    },
    [filter, MonthNames, quarter],
  );
  // Handle changes to the month selection and update state accordingly, ensuring that the selected month is valid based on the current fiscal year and available months
  const changeMonthHandler = useCallback((e) => {
    setMonths(e.target.value);
  }, []);
  // Format date strings for display in the filter summary, using UK date format (dd/MM/yyyy) for better readability in the context of the application
  const formatDate = useCallback((dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }, []);
  // Handle changes to the date selection in the custom date range filter, ensuring that the "from" date is not after the "to" date and vice versa, with appropriate state updates and validation
  const DateChange = useCallback(
    (value, type) => {
      if (type === "from") {
        setFromDate(value);
        if (toDate && value && value > toDate) {
          setToDate(null);
        }
      } else if (type === "to") {
        if (!fromDate || value >= fromDate) {
          setToDate(value);
        } else {
          // Handle invalid date selection
          setToDate(null);
        }
      }
    },
    [fromDate, toDate],
  );
  // Calculate dynamic pagination options
  const calculatePaginationOptions = useCallback((totalRecords, interval) => {
    const opts = [];
    for (let i = interval; i <= totalRecords; i += interval) {
      opts.push(i);
    }
    return opts;
  }, []);
  // Calculate total records and pagination options based on the length of the abandoned cart data, ensuring that pagination options are updated dynamically as the data changes
  const totalRecords = abandonedcart.length; // Get the total records count
  // Memoize pagination options to avoid unnecessary recalculations when the total records count changes
  const paginationOptions = useMemo(
    () => calculatePaginationOptions(totalRecords, 10),
    [totalRecords, calculatePaginationOptions],
  );
  // Generate fiscal year options for the period filter, starting from 2023 up to the current fiscal year, and memoize the options to optimize performance
  const options = useMemo(() => {
    const arr = [];
    for (let i = currentyear; i >= 2023; i--) {
      if (i === currentyear && currentMonth < 9) {
        continue;
      }
      const year = i;
      arr.push(
        <option key={year} value={year + "-" + (year + 1)}>
          {year + "-" + (year + 1)}
        </option>,
      );
    }
    return arr;
  }, [currentyear, currentMonth]);
  // Calculate visible month names based on the selected fiscal year and the current date, ensuring that future months in the current fiscal year are not displayed as options in the month filter
  const currentFiscalYear = getCurrentFiscalYear();
  let visibleMonthNames = MonthNames;
  if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
  }
  // Add loading buffer class to the container when data is being loaded to provide visual feedback to the user
  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <div
      className={`chart-container chart-abandd-cart ${loadingbuffer}`}
      style={{ verticalAlign: "top" }}
    >
      <div className="chart-Hdr">
        <div className="chart-Hdr-txt">
          <h2>{t("abandoned_cart_txt")}</h2>
        </div>
        <div
          className="chart-fltr"
          onMouseEnter={() => {
            if (filter === "custom" && !showDatePicker) {
              setShowDatePicker(true);
            }
          }}
          onMouseLeave={() => {
            if (filter === "custom" && showDatePicker) {
              setShowDatePicker(false);
            }
          }}
        >
          {
            <select value={filter} onChange={(e) => changeFilterHandler(e)}>
              <option value={0}>{t("all_txt")}</option>
              <option value={"weekly"}>{t("current_week_txt")}</option>
              <option value={"monthly"}>{t("monthly_txt")}</option>
              <option value={"quarterly"}>{t("quarterly_txt")}</option>
              <option value={"FYdata"}>{t("fy_data_txt")}</option>
              <option value={30}>{t("past_30_days_txt")}</option>
              <option value={90}>{t("past_90_days_txt")}</option>
              <option value={180}>{t("past_180_days_txt")}</option>
              <option value={365}>{t("past_1_year_txt")}</option>
              <option value={"custom"}>{t("custom_date_txt")}</option>
            </select>
          }
          {showDatePicker && (
            <div className="date-picker-container">
              <label>{t("from_txt")}:</label>
              <DatePicker
                selected={fromDate}
                onChange={(date) => DateChange(date, "from")}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
              <label>{t("to_txt")}:</label>
              <DatePicker
                selected={toDate}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                onChange={(date) => DateChange(date, "to")}
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
            </div>
          )}
          {filter === "quarterly" && (
            <select
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              {getAvailableQuarters(period)}
            </select>
          )}
          {filter === "monthly" && (
            <select value={months} onChange={(e) => changeMonthHandler(e)}>
              {visibleMonthNames.map((monthName, index) => {
                const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                return (
                  <option key={monthNumber} value={monthNumber}>
                    {monthName}
                  </option>
                );
              })}
            </select>
          )}
          {(filter === "monthly" ||
            filter === "quarterly" ||
            filter === "FYdata") && (
            <select value={period} onChange={(e) => changePeriodHandler(e)}>
              {options}
            </select>
          )}
        </div>
        <div className="fltr-sub-val">
          {abandonedcart.length > 0 && (
            <span className="fltr-val">
              {t("total_records")?.replace("{{count}}", abandonedcart.length)}{" "}
              {[
                t("current_week_txt"),
                t("monthly_txt"),
                t("quarterly_txt"),
                t("fy_data_txt"),
              ].includes(filtertext)
                ? ""
                : filtertext != "" && filtertext != t("custom_date_txt")
                  ? " (" + filtertext + ")"
                  : filtertext === t("custom_date_txt") && fromDate && toDate
                    ? " (" +
                      formatDate(fromDate) +
                      " - " +
                      formatDate(toDate) +
                      ")"
                    : " (" + t("all_txt") + ")"}
            </span>
          )}
        </div>
      </div>
      <DataTable
        columns={columns}
        data={abandonedcart}
        customStyles={customStyles}
        noDataComponent={
          <div className="no-records-found">
            {t("no_data_filtered_search_txt")}
          </div>
        }
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
        paginationComponentOptions={paginationComponentOptions}
      />
      {popupView && (
        <Popup
          extClass="order-pop abandoned-cart-details-pop"
          headMoreTxt={
            <>
              <div className="order-top">
                <div className="bottom order-flex">
                  <div className="order_account_details abandoned-cart-left">
                    <p>
                      {t("name_txt")}:{" "}
                      <span className="date">
                        {customerDetails.accountName}
                      </span>{" "}
                    </p>
                    <p>
                      {t("account_code_txt")}:{" "}
                      <span className="date">
                        {customerDetails.accountCode}
                      </span>{" "}
                    </p>
                    <p>
                      {t("route_days")}:{" "}
                      <span className="pay">
                        {customerDetails.accountDeliverableDays === "All"
                          ? t("all_weekdays_txt")
                          : customerDetails.accountDeliverableDays}
                      </span>
                    </p>
                  </div>
                  <div className="order_account_details">
                    <p>
                      {t("telephone_number_txt")}:{" "}
                      <span className="date">
                        {customerDetails.accountTelephone}
                      </span>{" "}
                    </p>
                    <p>
                      {t("email_address_txt")}:{" "}
                      <span className="pay">
                        {customerDetails.accountEmail}
                      </span>
                    </p>
                    <p>
                      {t("address_txt")}:{" "}
                      <span className="pay">{customerDetails.addressInfo}</span>
                    </p>
                  </div>
                </div>
              </div>
            </>
          }
          closebtn={
            <>
              <div className="pop-header-top order-top">
                <div className="head">
                  <h4>{t("abandoned_cart_details_txt")}</h4>
                </div>
                <span
                  onClick={() => setPopupView(false)}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="modal-table">
                <h4 className="item-title">{t("added_items_txt")}</h4>
                {loading && (
                  <div className="loading-overlay">
                    <div className="loading-message">{t("loading_txt")}</div>
                  </div>
                )}
                {!loading && (
                  <div className="checkout-table">
                    <div className="table_overflow">
                      <table>
                        <thead>
                          <tr>
                            <td>{t("product_txt")}</td>
                            <td align="center">{t("unit_of_sale_txt")}</td>
                            <td align="center">{t("item_added_on_txt")}</td>
                            <td align="center">{t("quantity_txt")}</td>
                            <td align="center">{t("price_txt")}</td>
                            <td align="right">{t("total_txt")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.length > 0 &&
                            cartItems.map((item, index) => {
                              return (
                                item.qty > 0 && (
                                  <tr
                                    key={index}
                                    className={
                                      item.itemPrice === 0 ||
                                      item.productType === "CH"
                                        ? "free-prod-bg"
                                        : ""
                                    }
                                  >
                                    <td
                                      data-title={t("product_txt")}
                                      className="data-product-hide"
                                    >
                                      {strReplaceCb(item.productDescription)} (
                                      {item.productNumber.includes("_")
                                        ? item.productNumber.substring(
                                            0,
                                            item.productNumber.indexOf("_"),
                                          )
                                        : item.productNumber}
                                      )
                                    </td>
                                    <td
                                      data-title={t("unit_of_sale_txt")}
                                      align="center"
                                    >
                                      {item.packageSize}
                                    </td>
                                    <td
                                      data-title={t("dateform_txt")}
                                      align="center"
                                    >
                                      {dateformatwithuktime(item.createdAt)}
                                    </td>
                                    <td
                                      data-title={t("quantity_txt")}
                                      align="center"
                                    >
                                      {item.qty}
                                    </td>
                                    <td
                                      data-title={t("price_txt")}
                                      align="center"
                                    >
                                      {priceFormatCb(item.itemPrice)}
                                    </td>
                                    <td
                                      data-title={t("total_txt")}
                                      align="right"
                                    >
                                      {priceFormatCb(item.itemTotal)}
                                    </td>
                                  </tr>
                                )
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </>
          }
        />
      )}
    </div>
  );
};
